import { useState } from "react"
import { useHistory, useLocation } from "react-router-dom"

export const useVariablesExportFile = () => {
  const { push } = useHistory()
  const { pathname } = useLocation()
  const [formId, setFormId] = useState("")
  const [messageConfirmDownload, setMessageConfirmDownload] = useState("")
  const [isOpenModalExport, setIsOpenModalExport] = useState(false)

  return {
    formId,
    isOpenModalExport,
    messageConfirmDownload,
    pathname,
    push,
    setFormId,
    setIsOpenModalExport,
    setMessageConfirmDownload,
  }
}
